var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from '@angular/core';
import { A3iService } from 'app/services/a3i.service';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { DomainService } from 'app/services/domain.service';
import { EditService } from 'app/services/edit.service';
import { GtoService } from 'app/services/gto.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { MainDataService } from 'app/services/main-data.service';
import { ToastrService } from 'ngx-toastr';
var A3iEditCardComponent = /** @class */ (function () {
    function A3iEditCardComponent(toastr, activityService, attrIndexService, a3iService, commonService, domainService, editService, gtoService, qcService, mainDataService) {
        this.toastr = toastr;
        this.activityService = activityService;
        this.attrIndexService = attrIndexService;
        this.a3iService = a3iService;
        this.commonService = commonService;
        this.domainService = domainService;
        this.editService = editService;
        this.gtoService = gtoService;
        this.qcService = qcService;
        this.mainDataService = mainDataService;
        this.disableEditing = false;
        this.editRecordList = [];
        this.domainsByColumn = {};
    }
    A3iEditCardComponent.prototype.onChange = function (col) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.selectedRecord) {
                    return [2 /*return*/];
                }
                if (!this.selectedRecord[this.isEditedCol]) {
                    this.selectedRecord[this.isEditedCol] = true;
                    this.editRecordList.push(this.selectedRecord);
                }
                if (this.a3iService.commitDisableBS.getValue().disabled) {
                    this.a3iService.commitDisableBS.next({
                        disabled: false
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    A3iEditCardComponent.prototype.checkFieldDirty = function (col) {
        var originAttrs = this.mainDataService.getDataOriginAttrs(this.a3iService.getRecordId(this.selectedRecord));
        if (originAttrs) {
            return this.editService.hasValueChanged(this.selectedRecord[col.prop], originAttrs[col.prop]);
        }
    };
    A3iEditCardComponent.prototype.goPrevRecord = function () {
        var idx = this.editRecordList.indexOf(this.selectedRecord);
        if (idx <= 0) {
            return;
        }
        this.changeSelectedRecord(this.editRecordList[idx - 1]);
    };
    A3iEditCardComponent.prototype.goNextRecord = function () {
        var idx = this.editRecordList.indexOf(this.selectedRecord);
        if (idx >= this.editRecordList.length - 1) {
            return;
        }
        this.changeSelectedRecord(this.editRecordList[idx + 1]);
    };
    A3iEditCardComponent.prototype.clear = function () {
        this.editRecordList = [];
        this.selectedRecord = null;
        if (!this.a3iService.commitDisableBS.getValue().disabled) {
            this.a3iService.commitDisableBS.next({
                disabled: true
            });
        }
    };
    A3iEditCardComponent.prototype.changeSelectedRecord = function (rec, skipTrigger) {
        if (rec) {
            this.selectedRecord = rec;
        }
        else {
            this.selectedRecord = null;
        }
        if (!skipTrigger) {
            this.a3iService.selectedRecordA3iBS.next({
                record: this.selectedRecord,
                source: 'card'
            });
        }
    };
    A3iEditCardComponent.prototype.commit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var spinnerId, originList, data, gtos, err_1, layer, dynamicQcKeyvals, editFilters, rsp, err_2, err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, , 13]);
                        originList = this.editRecordList.map(function (i) {
                            return _this.mainDataService.getDataOriginAttrs(_this.a3iService.getRecordId(i));
                            // return i[this.attrIndexService.originalDataKey]
                        });
                        return [4 /*yield*/, this.handleEditedRecordList(this.editRecordList, originList)];
                    case 2:
                        data = _a.sent();
                        gtos = data.gtos;
                        if (!gtos.length) return [3 /*break*/, 11];
                        console.log(gtos);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.gtoService.processGto(gtos)];
                    case 4:
                        _a.sent();
                        this.toastr.success('Successfully updated.');
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        this.toastr.error('Update failed.');
                        console.log(err_1);
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                    case 6:
                        _a.trys.push([6, 9, , 10]);
                        layer = this.activityService.selectedLayerBS.getValue().layer;
                        dynamicQcKeyvals = data.dynamicQcKeyvals;
                        editFilters = [{
                                gly_id: layer.id,
                                cols: data.changedCols,
                                keyvals: dynamicQcKeyvals
                            }];
                        if (!data.changedCols.length) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.qcService.qcLayersDynamic(editFilters)];
                    case 7:
                        rsp = _a.sent();
                        if (rsp.misc && rsp.misc.transition > 0) {
                            this.qcService.qcLayers([layer.id]);
                        }
                        _a.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 10];
                    case 10:
                        this.a3iService.commitSubject.next({
                            state: 'done'
                        });
                        _a.label = 11;
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        err_3 = _a.sent();
                        console.log(err_3);
                        return [3 /*break*/, 13];
                    case 13:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    A3iEditCardComponent.prototype.handleEditedRecordList = function (list, originList) {
        return __awaiter(this, void 0, void 0, function () {
            var layer, sourceTableName, changedCols, updateGtos, gtos, updateRecords, updateRecordsOrigin, prefix, dynamicQcKeyvals, cols, primKeyCol, updateGtosInfo;
            var _this = this;
            return __generator(this, function (_a) {
                if (!list.length) {
                    return [2 /*return*/];
                }
                layer = this.activityService.selectedLayerBS.getValue().layer;
                sourceTableName = layer.category.tableName;
                changedCols = [];
                gtos = [];
                updateRecords = [];
                updateRecordsOrigin = [];
                list.forEach(function (r) {
                    updateRecords.push(r);
                    var origin = originList.find(function (o) { return _this.a3iService.getRecordId(o) === _this.a3iService.getRecordId(r); });
                    updateRecordsOrigin.push(origin);
                });
                prefix = layer.category.colPrefix;
                cols = this.editService.getUpdateColsInSourceTable(sourceTableName, prefix);
                primKeyCol = this.editService.getPrimKeyCol(prefix);
                if (updateRecords.length) {
                    dynamicQcKeyvals = updateRecords.map(function (r) { return _this.a3iService.getRecordId(r); });
                    updateGtosInfo = this.editService.getUpdateGtosByRecordsArchive(cols, updateRecords, updateRecordsOrigin, sourceTableName, prefix, primKeyCol, this.attrIndexService.geomColManual);
                    updateGtos = updateGtosInfo.gtos;
                    changedCols = updateGtosInfo.changedCols;
                    gtos = gtos.concat(updateGtos);
                }
                changedCols = changedCols.filter(function (c) { return c; });
                return [2 /*return*/, {
                        gtos: gtos,
                        changedCols: changedCols,
                        dynamicQcKeyvals: dynamicQcKeyvals
                    }];
            });
        });
    };
    A3iEditCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isEditedCol = this.attrIndexService.isEditedKey;
        this.selectedRecSub = this.a3iService.selectedRecordA3iBS.subscribe(function (data) {
            if (data.source !== 'card') {
                _this.changeSelectedRecord(data.record, true);
            }
        });
        this.columnsSub = this.a3iService.a3iEditColumnsBS.subscribe(function (data) {
            _this.columns = data.columns;
            var layer = _this.activityService.selectedLayerBS.getValue().layer;
            var colsForDomain = _this.columns.map(function (c) {
                return {
                    prop: c.prop,
                    standard: layer.category.standardCols.find(function (s) { return s.colName.toLowerCase() === c.prop.substring(4); })
                };
            });
            _this.domainsByColumn = _this.domainService.getColumnDomains(colsForDomain, layer.category.code, _this.selectedRecord);
        });
        this.commitSub = this.a3iService.commitSubject.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(data.state === 'start')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.commit()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    A3iEditCardComponent.prototype.ngOnDestroy = function () {
        this.selectedRecSub.unsubscribe();
        this.columnsSub.unsubscribe();
        this.commitSub.unsubscribe();
    };
    return A3iEditCardComponent;
}());
export { A3iEditCardComponent };
